module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("95uyf"))).then(() => parcelRequire('d0iPb'));